"use strict";
/*
 * Created on 25. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var utils_1 = require("../../core/utils");

var SparseMatrix_1 = require("../../core/utils/SparseMatrix");

var CannibalizationItem_1 = require("./CannibalizationItem");

var WindowPromoEffectSiteBase_1 = require("./WindowPromoEffectSiteBase");

var WindowPromoEffectSite =
/*#__PURE__*/
function (_WindowPromoEffectSit) {
  _inherits(WindowPromoEffectSite, _WindowPromoEffectSit);

  function WindowPromoEffectSite(id, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmount, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, historic, siteId) {
    var _this;

    _classCallCheck(this, WindowPromoEffectSite);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoEffectSite).call(this, id, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmount, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, historic, siteId));
    _this.cannibalizationMatrix = _this.cannibalization.reduce(function (acc, ci) {
      acc.set(ci.cannibal, ci.victim, ci.amount);
      return acc;
    }, SparseMatrix_1.SparseMatrix.stringStringMatrix(big_decimal_1.BigDecimal.ZERO));
    _this.userTotals = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.userTotalAmounts)));
    _this.positiveIncrements = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.positiveIncrementAmounts)));
    _this.postPromo = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.postPromoAmounts)));
    _this.postPromoEnds = immutable_1.Map(immutable_1.List(_this.products).zip(immutable_1.List(_this.postPromoDates)));
    _this.baseline = immutable_1.Map(immutable_1.List(_this.baselineProducts).zip(immutable_1.List(_this.baselineAmounts)));
    return _this;
  }

  _createClass(WindowPromoEffectSite, [{
    key: "setCannibalization",
    value: function setCannibalization(matrix) {
      return this.copyMulti({
        cannibalizationMatrix: matrix,
        cannibalization: immutable_1.Seq(matrix).map(function (it) {
          return new CannibalizationItem_1.CannibalizationItem(it[0], it[1], it[2]);
        }).toArray()
      });
    }
  }]);

  return WindowPromoEffectSite;
}(WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase);

exports.WindowPromoEffectSite = WindowPromoEffectSite;
WindowPromoEffectSite.EMPTY = new WindowPromoEffectSite(utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, utils_1.Utils.VOID_ID, [], [], [], [], [], [], [], [], [], false, utils_1.Utils.VOID_ID);